enum EmailDisplayMode {
    TABLE = "TABLE",
    MOSAIC = "MOSAIC",
}

export default EmailDisplayMode;
